import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { InputType } from "../../services/inputTypesApi";

interface InputTypeComboboxProps {
  inputTypes: InputType[];
  isLoading?: boolean;
  selectedValue: string;
  onSelect: (value: string) => void;
  placeholder?: string;
}

// Despite the legacy name, this is a shadcn <Select>, not a Combobox. Renamed
// in spirit but kept exported as InputTypeCombobox to avoid touching callers.
export const InputTypeCombobox = ({
  inputTypes,
  isLoading,
  selectedValue,
  onSelect,
  placeholder = "Select input type...",
}: InputTypeComboboxProps) => {
  return (
    <Select
      value={selectedValue}
      onValueChange={onSelect}
      disabled={isLoading}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder={isLoading ? "Loading..." : placeholder} />
      </SelectTrigger>
      <SelectContent>
        {inputTypes.map((type) => (
          <SelectItem key={type.id} value={type.id}>
            {type.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
